/**
 * A FAIXA DO AMBIENTE: "AUDITORIA — DADOS DESCARTÁVEIS" no ambiente fechado, e "TESTE", discreta,
 * no de teste. Em produção ela não existe.
 *
 * Pedido do Cristiano, de 16/10/2026, e pedido da auditora no mesmo dia: um ambiente de dados
 * descartáveis que parece produção é o jeito de alguém digitar dinheiro de verdade no lugar errado,
 * ou de um print de teste ser lido como de produção.
 *
 * **Ela fica acima de TUDO**, inclusive das telas sem sessão (entrar, o link da senha, a
 * Administração), porque é exatamente nelas que alguém confunde o endereço. **Quem diz o ambiente
 * é o servidor**, pelo `/v1/sobre`, e não o endereço da página: o mesmo painel é servido pelos três.
 *
 * Ela não sai no papel (`so-tela`), como a barra de cima e a faixa do treinamento.
 */
import { useEffect, useState, type JSX } from 'react'
import { servidor } from '../api'
import { ehParaImprimir } from '../rotas'

type Ambiente = 'producao' | 'teste' | 'auditoria' | 'desenvolvimento'

export function FaixaDoAmbiente(): JSX.Element | null {
  const [ambiente, setAmbiente] = useState<Ambiente | null>(null)

  useEffect(() => {
    servidor
      .sobre()
      .then((s) => setAmbiente((s.ambiente ?? null) as Ambiente | null))
      // Servidor fora do ar: sem faixa, e a tela de baixo diz o que houve.
      .catch(() => setAmbiente(null))
  }, [])

  if (ehParaImprimir()) return null

  if (ambiente === 'auditoria') {
    return (
      <div className="faixa-ambiente auditoria so-tela" role="note" data-ambiente="auditoria">
        <strong>AUDITORIA — DADOS DESCARTÁVEIS</strong>
        <span>nada daqui é de verdade, e tudo pode ser apagado</span>
      </div>
    )
  }

  if (ambiente === 'teste') {
    return (
      <div className="faixa-ambiente teste so-tela" role="note" data-ambiente="teste">
        TESTE
      </div>
    )
  }

  return null
}
